import { createContext } from 'react';

export type UserRole = 'admin' | 'regular';

export interface UserInfo {
  id?: string | null;
  email?: string | null;
  name?: string | null;
  picture?: string | null;
  /** `null` when the backend could not resolve a role — see `canDestroy`. */
  role?: UserRole | null;
}

export interface AuthContextType {
  token: string | null;
  isAuthenticated: boolean;
  /** True when VITE_SKIP_AUTH is enabled (local dev without Google sign-in). */
  authBypassActive: boolean;
  user: UserInfo | null;
  role: UserRole | null;
  isAdmin: boolean;
  /**
   * Whether destructive controls (kill job, delete job, delete background)
   * should be offered. Deliberately fails open: only a user the backend
   * positively identified as `regular` loses them, so an unreachable users
   * endpoint leaves the UI exactly as it behaved before roles existed.
   */
  canDestroy: boolean;
  roleLoading: boolean;
  refreshUser: () => Promise<void>;
  login: (newToken: string) => void;
  logout: () => void;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);
